/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Colstatus2Inputs */

const zh_adminsubs_colstatus2 = /** @type {(inputs: Adminsubs_Colstatus2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态`)
};

const en_adminsubs_colstatus2 = /** @type {(inputs: Adminsubs_Colstatus2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const es_adminsubs_colstatus2 = /** @type {(inputs: Adminsubs_Colstatus2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Adminsubs_Colstatus2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_colstatus2 = /** @type {((inputs?: Adminsubs_Colstatus2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Colstatus2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_colstatus2(inputs)
	if (locale === "en") return en_adminsubs_colstatus2(inputs)
	return es_adminsubs_colstatus2(inputs)
});
export { adminsubs_colstatus2 as "adminSubs_colStatus" }